import * as s from 'superstruct';

const FileStruct = s.type({
  url: s.string(),
  size: s.number(),
});

export const UploadResponseStruct = s.array(s.type({
  hash: s.string(),
  name: s.string(),
  size: s.number(),
  protected: s.optional(s.boolean()),
}))

export const PdfEditResponseStruct = s.type({
  result: s.union([
    s.record(s.string(), s.type({
      files: s.array(FileStruct),
    })),
    s.type({
      zip: FileStruct,
    }),
  ]),
});

export const ConvertResponseStruct = s.type({
  result: s.array(FileStruct),
  zip: s.optional(FileStruct),
});

export const UnlockResponseStruct = s.type({
  result: s.string(),
});

export const CompressResponseStruct = s.type({
  result: FileStruct,
});

export default s;
